import { Command } from '../../_base/actionBus/Command';

export class ResetPassword extends Command {
    constructor(public password: string, public confirmationPassword: string) {
        super();
    }
}
